<template>
<v-main>
  <div style='height:93.8vh;' width='100%'>
    <v-container fluid :class='!$vuetify.breakpoint.mobile ? "fill-height py-1 px-4" : "fill-height py-0 px-0"'>
      <v-row class='fill-height'>
        <v-col :cols='activeGroup ? 3 : 12' v-if='!($vuetify.breakpoint.mobile && activeGroup)'>
          <v-card class='fill-height'>
            <v-toolbar dark color='primary' flat>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn icon v-on:click="refreshMsgGroups" v-if="!gettingMsgGroups"><v-icon>mdi-refresh</v-icon></v-btn>
              <v-progress-circular indeterminate color="white" v-if="gettingMsgGroups"></v-progress-circular>
              <newContact></newContact>
            </v-toolbar>
            <chat-groups></chat-groups>
          </v-card>
        </v-col>
        <v-col :cols='!$vuetify.breakpoint.mobile ? 9 : 12' v-if='activeGroup'>
          <chat v-if='activeGroup' :localuid='local_uid'></chat>
        </v-col>
      </v-row>
    </v-container>
  </div>
</v-main>
</template>

<script >
import { mapState } from 'vuex';
import NewContact from '../components/new-contact.vue';
import Common from '../mixins/common.vue';
import Chat from '../components/Chat.vue';
import ChatGroups from '../components/ChatGroups.vue'

const scrollToBottom = function () {
        let messages = document.getElementById('messages');
        messages.scrollTop = messages.scrollHeight;
        setTimeout(() => {
            messages.scrollTop = messages.scrollHeight;
        }, 400);
}

export default {
  mixins: [Common],
  data() {
    return {
      navopen: 1,
      viewMsgGroupId: null,
      viewMsgGroupName: null,
      showNewContact: false,
      search: '',
    };
  },
  computed: {
    activeGroup: {
      get() {
        return this.$store.state.activeMsgGroup;
      }
    },
    groups: {
      get() {
        return this.$store.state.msgGroups;
      }
    },
    local_uid() { return this.user.user_id },
    msgGroupsStatic: {
      get() {
        return this.$store.state.msgGroups;
      }
    },
    gettingMsgGroups: {
      get() {
        return this.$store.state.gettingMsgGroups;
      },
    },

  },
  components: {
    'newContact': NewContact,
    'chat': Chat,
    'chat-groups': ChatGroups,
  },
  methods: {
    debug: function(e) {
      console.log('debug: ', e)
    },
    selectGroup: function(group) {
      this.activeGroup = this.getMsgGroupStaticOrDynamic(group);
    },
    hasUnreadMessages: function(group) {
       return group.unread_messages>0;
    },
    onClosenewcontact: function(groupId) {
      this.showNewContact=false;
      if (groupId) {
        this.navopen = 0;
        this.viewMsgGroupId = groupId;
      } else {
        this.navopen=1;
      }
    },
    refreshMsgGroups: function() {
      this.$store.dispatch('getMsgGroups');
    },
    numOfMembers: function(group) {
      for (let i=0;i<this.msgGroupsStatic.length;i++) {
        let mgStatic = this.msgGroupsStatic[i];
        if (mgStatic.msg_group_id == group.msg_group_id) {
          return mgStatic.MsgGroupMembers.length;
        }
      }
      return 0;
    },
    getMsgGroupStatic: function(groupId) {
      for (let i=0;i<this.msgGroupsStatic.length;i++) {
        let mgStatic = this.msgGroupsStatic[i];
        if (mgStatic.msg_group_id == groupId) {
          return mgStatic;
        }
      }
      return null;
    },
    getMsgGroupStaticOrDynamic: function(dynamicGroup) {
      let group = this.getMsgGroupStatic(dynamicGroup.msg_group_id);
      if (group) {
        return group;
      }

      // still here? its possible that the group
      // was just created and so we don't have a
      // static / hardcoded group until the next
      // time the app loads. So we'll just pass the
      // dynamic version of the group
      return dynamicGroup;
    }
  },
  // watch the search variable and filter the groups
  // based on the search string
  watch: {
    search: function(val) {
      if (val) {
        this.$store.commit('msgGroupSearch', val);
      } else {
        this.$store.commit('msgGroupSearch', null);
      }
    }
  },
  mounted: function() {
    console.log(this.groups);
    global.api.userAction('chats_read', null, 'webphone');
  }
};
</script>

<style>
html, body {
  margin:0px;
  height:100%;
}

.wrapperCard {
  height:205%;
}
.fillHeight {
  height:100%;
}
.opensidenav {
  width: 80% !important;
}

.hasUnreadMessages {
  font-weight: bold;
}

.hamburger {
  height: 45px;
  width: 45px; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 4; /* Stay on top, but under side nav */
  top: 40px; /* Stay at the top */
  left: 0;
  color: white;
  background-color: rgb(232, 233, 229);
  overflow: hidden;
  font-size: 32px;
  padding-left: 8px;
  padding-right: 8px;
}

/* The side navigation menu */
.sidenav {
  height: calc(100vh - 40px); /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 5; /* Stay on top */
  top: 40px; /* Stay at the top */
  left: 0;
  background-color: #ccc; /* light gray */
  overflow-x: scroll; /* Disable horizontal scroll */
  overflow-y:scroll;
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
}
</style>
